import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    deferredPrompt: null,
    isInstallPromptShown: false,
  },
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
  mutations: {
    setDeferredPrompt(state, payload) {
      state.deferredPrompt = payload
    },
    setShowInstallPrompt(state, payload) {
      state.isInstallPromptShown = payload
    },
  },
  actions: {
    saveDeferredPrompt({ commit }, event) {
      commit('setDeferredPrompt', event)
      commit('setShowInstallPrompt', true)
    },
  },
})
